import { render, staticRenderFns } from "./ToRate.vue?vue&type=template&id=e3a5278a&"
import script from "./ToRate.vue?vue&type=script&lang=ts&"
export * from "./ToRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports